export default function needsToAddMoreItems(cart) {
  return cart.needsToAdd !== 0;
}
